/**
 * @generated SignedSource<<7dfeea391d88c177ea5b72690d62e68d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FileErrorReason = "CONVERSION_ERROR" | "TIMEOUT" | "TOO_LARGE" | "TYPE_NOT_SUPPORTED" | "UNKNOWN";
export type FileStatus = "ERROR" | "PENDING" | "PROCESSING" | "READY" | "WAIT_FOR_PROCESSING";
import { FragmentRefs } from "relay-runtime";
export type SuggestionItemStatusDetail_File$data = {
  readonly errorReason: FileErrorReason | null;
  readonly status: FileStatus;
  readonly " $fragmentType": "SuggestionItemStatusDetail_File";
};
export type SuggestionItemStatusDetail_File$key = {
  readonly " $data"?: SuggestionItemStatusDetail_File$data;
  readonly " $fragmentSpreads": FragmentRefs<"SuggestionItemStatusDetail_File">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SuggestionItemStatusDetail_File",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorReason",
      "storageKey": null
    }
  ],
  "type": "File",
  "abstractKey": null
};

(node as any).hash = "8c64fa170feaafd3bfd5c6f02075ca51";

export default node;
